import { Component, Input } from '@angular/core';
import { EventsProvider } from '../../providers/events/events';
import { ClientDetailsProvider } from '../../providers/client-details/client-details';
import { AppState } from '../../config/state';
import { Platform, NavController, PopoverController } from 'ionic-angular';
import { ConfigProvider } from '../../providers/config/config';
import { CoEventDetailsComponent } from '../co-event-details/co-event-details';
import { CoLocationComponent } from '../co-location/co-location';
import { Events } from 'ionic-angular';
import { SocialMediaSharingProvider } from '../../providers/social-media-sharing/social-media-sharing';

/**
 * Generated class for the CoEventsFeaturedCardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-events-featured-card',
  templateUrl: 'co-events-featured-card.html',
  inputs: ['featuredEvent']
})
export class CoEventsFeaturedCardComponent {
  // searchTypes: any;
  clientKeyword: any;
  viewType: any;
  screenWidth: any;
  aboveWidthBreakpoint: boolean;
  loadPage: boolean = false;
  isSharedScreen: boolean;
  eventTypes: any;
  @Input('featuredEvent') event: any;

  constructor(public eventsProvider: EventsProvider, private clientDetails: ClientDetailsProvider, public state: AppState, public platform: Platform, public config: ConfigProvider, public navCtrl: NavController, public popoverCtrl: PopoverController, private events: Events, private socialShare: SocialMediaSharingProvider) {
    let self = this;
    this.clientDetails.load().then(function (response) {
      self.clientKeyword = response.keyword;
      self.viewType = state.mode;
      self.screenWidth = self.platform.width();
      self.platform.width()>992? self.aboveWidthBreakpoint = true: self.aboveWidthBreakpoint = false;
    });
    this.isSharedScreen = this.state.sharedScreen;
    if(!this.state.eventColors) {
      this.eventsProvider.getEventTypes().then( types => {
        this.eventTypes = types;
      });
    } else {
      this.eventTypes = this.state.eventColors.types;
    }
  }

  // ngOnInit(){
  //   this.getExploreEvents(this.event)
  //   console.log('event', this.event)
  // }
  ngOnDestroy(){
    this.events.unsubscribe('updateAllEvents');
  }

  getExploreEvents(event) {
    // let eventsFilter = `startDate: "${moment().startOf('day').format("YYYY-MM-DD HH:mm:ss")}", globalFeatured: true`;
    // this.eventsProvider.getEvents(eventsFilter).then((info) => {
    //   // this.searchTypes = info.searchTypes;
    //   let allEvents = info.allEvents;
    //   this.event = allEvents[Math.floor(Math.random() * allEvents.length)];
    //   this.events.subscribe('updateAllEvents', async () => {
    //     this.event = await this.eventsProvider.checkInterestedEvents(this.event);
    //   });
    //   if (this.event) this.loadPage = true;
    // });

    if (event) this.loadPage = true;
    this.events.subscribe('updateAllEvents', async () => {
      this.event = await this.eventsProvider.checkInterestedEvents(this.event);
    });
  }

  goToEventDetails(eventId) {
    this.config.load(this.state.appId).then(cfg => {
      this.navCtrl.push(CoEventDetailsComponent, { eventId: eventId });
    });
  }

  goToLocation(locationId) {
    this.config.load(this.state.appId).then(cfg => {
      this.navCtrl.push(CoLocationComponent, { location: locationId });
    });
  }

  getEventImage(eventType) {
    try {
      let eventTypeObject = this.eventTypes.find(object => object.name === eventType);
      return eventTypeObject.image;
    } catch (ex) {
      return "";
    }
  }

  openInterestedPopover(event){
    let self = this;
    this.eventsProvider.openInterestedPopover(event, this.event, self);
  }

  shareEvent(button) {
    if (this.viewType === 'app') {
      this.socialShare.shareOptions(this.event);
    } else if (this.viewType === 'desktop') {
      this.eventsProvider.openSocialMediaPopover(button, this.event);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/co-events-featured-card/co-events-featured-card.ts